export default "__VITE_ASSET__Bb6j$bCo__"